import { render } from "./DetalharValor.vue?vue&type=template&id=558db815&scoped=true"
import script from "./DetalharValor.vue?vue&type=script&lang=js"
export * from "./DetalharValor.vue?vue&type=script&lang=js"

import "./DetalharValor.vue?vue&type=style&index=0&id=558db815&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-558db815"]])

export default __exports__